import fetch from './api'

let data = {appsystem: 'h5', app_id: '1'}

const LOGIN = params => {
  return fetch({
    url: 'api/v2/user/login',
    method: 'get',
    params: Object.assign(data, params)
  })
}
// 获取课程详情页弹窗数据
const VERSIONCHECK = params => {
  console.log(Object.assign(params),'params');
  return fetch({
    url: '/api/v3/ai/version/check',
    method: 'post',
    data: Object.assign(data, params)
  })
}
// 获取登录状态
const USERINFO = params => {
  return fetch({
    url: '/api/v2/user/info',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 发送验证码
const SENDCODE = params => {
  return fetch({
    url: '/api/v2/user/send/code',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 验证码登录
const LOGINCODE = params => {
  return fetch({
    url: '/api/v2/user/login/code',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 修改密码
const CHANGEPWD = params => {
  return fetch({
    url: '/api/v2/user/change/password',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 校验用户
const CHECKUSER = params => {
  return fetch({
    url: '/api/v2/user/check/user',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 获取列表
const GETLIST = params => {
  return fetch({
    url: '/api/v2/home/course',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 列表详情
const GETDETAIL = params => {
  return fetch({
    url: '/api/v2/course/list',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 是否展示底部购课咨询
const GETONLINECONSULTINFO = params => {
  return fetch({
    url: '/api/v3/onlineConsultInfo',
    method: 'get',
    params: Object.assign(data, params)
  })
}

// 强提醒
const GETMEMBERRIGHTS = params => {
  return fetch({
    url: '/api/v3/visitor/getMemberRights',
    method: 'get',
    params: Object.assign(data, params)
  })
}

// 是否企业微信用户（私域）
const CHECKADDEDWORkUSER = params => {
  return fetch({
    url: '/api/v3/userPortrait/checkAddedWorkUser',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 获取ticket
const TICKET = params => {
  return fetch({
    url: '/api/v2/user/h5/ticket',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 获取自助开课课程列表
const SELFLIST = params => {
  return fetch({
    url: '/api/v2/self/course/list',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 获取课程下自助开课节点
const HELPLIST = params => {
  return fetch({
    url: '/api/v2/self/help/list',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 自助开课保存
const HELPSAVE = params => {
  return fetch({
    url: '/api/v2/self/help/save',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 获取课前必做
const COMPULSORY = params => {
  return fetch({
    url: '/api/v2/home/compulsory',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 获取协议
const AGREEMENT = params => {
  return fetch({
    url: '/api/v1/agreement/list',
    method: 'post',
    data: Object.assign(data, params)
  })
}

// 阅读课前须知
const ADDSTUNOTICE = params => {
  return fetch({
    url: '/api/v2/user/addStuNotice',
    method: 'get',
    params: Object.assign(data, params)
  })
}

export default {
  LOGIN,
  USERINFO,
  SENDCODE,
  LOGINCODE,
  CHANGEPWD,
  GETLIST,
  CHECKUSER,
  GETDETAIL,
  GETONLINECONSULTINFO,
  GETMEMBERRIGHTS,
  CHECKADDEDWORkUSER,
  TICKET,
  SELFLIST,
  HELPLIST,
  HELPSAVE,
  COMPULSORY,
  AGREEMENT,
  ADDSTUNOTICE,
  VERSIONCHECK
}



// WEBPACK FOOTER //
// ./src/api/interface-list.js